if (!customElements.get('pdp-slider')) {
  customElements.define(
    'pdp-slider',
    class PdpSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-pdp-track]');
        this.prev = this.querySelector('[data-pdp-prev]');
        this.next = this.querySelector('[data-pdp-next]');
        if (!this.track) return;

        this.prev?.addEventListener('click', () => this.scrollBy(-1));
        this.next?.addEventListener('click', () => this.scrollBy(1));
        this.track.addEventListener('scroll', () => this.syncNav(), { passive: true });
        this.syncNav();
      }

      scrollBy(direction) {
        const amount = Math.max(this.track.clientWidth * 0.7, 240);
        this.track.scrollBy({ left: amount * direction, behavior: 'smooth' });
      }

      syncNav() {
        if (!this.prev || !this.next) return;
        const max = this.track.scrollWidth - this.track.clientWidth - 4;
        this.prev.disabled = this.track.scrollLeft <= 4;
        this.next.disabled = this.track.scrollLeft >= max;
      }
    }
  );
}

document.addEventListener('click', (event) => {
  const addBtn = event.target.closest('[data-pdp-add]');
  if (addBtn) {
    event.preventDefault();
    addMiniProduct(addBtn);
    return;
  }

  const ugc = event.target.closest('[data-pdp-ugc]');
  if (ugc) {
    if (ugc.classList.contains('is-playing') && event.target.closest('video')) return;
    event.preventDefault();
    playUgc(ugc);
  }
});

async function addMiniProduct(button) {
  const id = button.dataset.variantId;
  if (!id || button.disabled) return;
  button.disabled = true;

  try {
    const sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    const addUrl = window.FoxTheme?.routes?.cart_add_url || '/cart/add.js';
    const cartUrl = window.FoxTheme?.routes?.cart_url || '/cart.js';
    const fetchConfig = window.FoxTheme?.utils?.fetchConfig
      ? FoxTheme.utils.fetchConfig('javascript')
      : {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        };

    const response = await fetch(addUrl, {
      ...fetchConfig,
      body: JSON.stringify({
        items: [{ id, quantity: 1 }],
        sections: sectionsToBundle,
        sections_url: window.location.pathname,
      }),
    });
    const parsedState = await response.json();
    if (parsedState.status) throw new Error(parsedState.description || 'Add to cart failed');

    const cartConfig = window.FoxTheme?.utils?.fetchConfig
      ? FoxTheme.utils.fetchConfig()
      : { headers: { Accept: 'application/json' } };
    const cartJson = await (await fetch(cartUrl, { ...cartConfig })).json();
    cartJson.sections = parsedState.sections;

    if (window.FoxTheme?.pubsub?.publish) {
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
    }

    document.dispatchEvent(
      new CustomEvent('product-ajax:added', {
        detail: { product: parsedState },
      })
    );

    const cartDrawer = document.querySelector('cart-drawer');
    const useDrawer = FoxTheme?.settings?.cartType !== 'page';
    const hasSections = parsedState.sections && Object.keys(parsedState.sections).length > 0;

    if (useDrawer && cartDrawer) {
      if (hasSections) {
        cartDrawer.show(button);
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      }
    }
  } catch (error) {
    console.warn(error);
  } finally {
    button.disabled = false;
  }
}

function playUgc(card) {
  const video = card.querySelector('video');
  if (video) {
    card.classList.add('is-playing');
    video.muted = false;
    video.controls = true;
    bindUgcFullscreen(video);
    if (video.currentTime > 0 && video.currentTime < 0.5) {
      video.currentTime = 0;
    }
    video.play();
    return;
  }

  const url = card.dataset.videoUrl;
  if (!url) return;
  window.open(url, '_blank', 'noopener');
}

function setUgcFullscreen(video, on) {
  video.classList.toggle('is-fullscreen', on);
}

function bindUgcFullscreen(video) {
  if (video.dataset.fsBound === 'true') return;
  video.dataset.fsBound = 'true';
  video.addEventListener('webkitbeginfullscreen', () => setUgcFullscreen(video, true));
  video.addEventListener('webkitendfullscreen', () => setUgcFullscreen(video, false));
}

function syncUgcFullscreen() {
  const fs = document.fullscreenElement || document.webkitFullscreenElement;
  document.querySelectorAll('.pdp-ugc video').forEach((video) => {
    setUgcFullscreen(video, fs === video);
  });
}

document.addEventListener('fullscreenchange', syncUgcFullscreen);
document.addEventListener('webkitfullscreenchange', syncUgcFullscreen);

function hideRechargeWidgets(root = document.querySelector('.pdp-main')) {
  if (!root) return;
  if (!root.querySelector('pdp-subscribe') && !root.hasAttribute('data-pdp-otp-only')) return;
  const injected = root.querySelectorAll(
    [
      'recharge-subscription-widget',
      '.recharge-subscription-widget',
      '[id^="RechargeWidget"]',
      '[class*="recharge-subscription"]',
      '.rc-container',
      '.rc-template',
      '#rc_container',
      '[data-recharge-widget]',
      'skio-plan-picker',
      '[class*="skio"]',
    ].join(',')
  );
  injected.forEach((el) => {
    if (el.classList.contains('pdp-recharge-sink')) return;
    el.hidden = true;
    el.style.setProperty('display', 'none', 'important');
  });

  root.querySelectorAll('a, button, summary, span').forEach((el) => {
    const text = (el.textContent || '').trim();
    if (/^subscription details$/i.test(text)) {
      const wrap = el.closest('[class*="recharge"], [class*="rc-"], div') || el;
      wrap.hidden = true;
      wrap.style.setProperty('display', 'none', 'important');
    }
  });
}

function primeUgcPosters(root = document) {
  root.querySelectorAll('.pdp-ugc video').forEach((video) => {
    if (video.dataset.ugcPrimed === 'true') return;
    video.dataset.ugcPrimed = 'true';
    video.muted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    const paintFrame = () => {
      if (video.classList.contains('is-fullscreen')) return;
      if (video.closest('.pdp-ugc__card.is-playing')) return;
      if (video.readyState < 1) return;
      if (video.currentTime >= 0.05) return;
      try {
        video.currentTime = 0.1;
      } catch (error) {
        /* Safari may throw if the media is not seekable yet */
      }
    };

    video.addEventListener('loadedmetadata', paintFrame);
    video.addEventListener('loadeddata', paintFrame);
    video.addEventListener('canplay', paintFrame);
    paintFrame();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  primeUgcPosters();
  bindPdpAccordions();
  hideRechargeWidgets();
  const root = document.querySelector('.pdp-main');
  if (!root || typeof MutationObserver === 'undefined') return;
  const observer = new MutationObserver(() => hideRechargeWidgets(root));
  observer.observe(root, { childList: true, subtree: true });
});

function bindPdpAccordions(root = document) {
  root.querySelectorAll('.pdp-acc').forEach((group) => {
    if (group.dataset.accBound === 'true') return;
    group.dataset.accBound = 'true';
    group.querySelectorAll('details.pdp-acc__item').forEach((item) => {
      const summary = item.querySelector('.pdp-acc__summary');
      if (!summary) return;
      item._pdpOpen = item.hasAttribute('open');
      summary.addEventListener('click', (event) => {
        event.preventDefault();
        const willOpen = !item._pdpOpen;
        if (willOpen) {
          group.querySelectorAll('details.pdp-acc__item').forEach((other) => {
            if (other !== item && other._pdpOpen) animatePdpAcc(other, false);
          });
        }
        animatePdpAcc(item, willOpen);
      });
    });
  });
}

function animatePdpAcc(item, open) {
  if (item._pdpOpen === open) return;
  item._pdpOpen = open;

  const summary = item.querySelector('.pdp-acc__summary');
  if (!summary) {
    item.open = open;
    return;
  }

  if (item._pdpAccFinish) {
    item.removeEventListener('transitionend', item._pdpAccFinish);
    item._pdpAccFinish = null;
  }

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) {
    item.open = open;
    return;
  }

  const closedHeight = summary.offsetHeight;
  item.style.overflow = 'hidden';

  if (open) {
    item.setAttribute('open', '');
    const openHeight = item.scrollHeight;
    item.style.height = `${closedHeight}px`;
    item.offsetHeight;
    item.style.transition = 'height 0.25s ease';
    item.style.height = `${openHeight}px`;
  } else {
    item.style.height = `${item.scrollHeight}px`;
    item.offsetHeight;
    item.style.transition = 'height 0.25s ease';
    item.style.height = `${closedHeight}px`;
  }

  item._pdpAccFinish = (event) => {
    if (event.target !== item || event.propertyName !== 'height') return;
    item.removeEventListener('transitionend', item._pdpAccFinish);
    item._pdpAccFinish = null;
    item.style.height = '';
    item.style.overflow = '';
    item.style.transition = '';
    if (!open) item.removeAttribute('open');
  };
  item.addEventListener('transitionend', item._pdpAccFinish);
}
